import axios from 'axios';
import { createAsyncThunk } from 'app/store/utils';
import { FetchDDLResponse } from 'types/api.types';
import { getProfileCountryDDLLink } from 'app/store/Profile/selectors';
import {
  getContributionCountryDDLLink,
  getCountryDDLLink,
} from 'app/store/SongList/selectors';

export const fetchCountriesEffect = createAsyncThunk(
  'countries/fetch',
  async (_, { getState }) => {
    const state = getState();
    const link =
      getProfileCountryDDLLink(state) ||
      getContributionCountryDDLLink(state) ||
      getCountryDDLLink(state);
    if (!link) {
      throw new Error('Country DDL link not found');
    }
    const response = await axios.get<FetchDDLResponse>(link);
    return {
      countryDDL: response.data,
    };
  }
);
